module.exports = __webpack_public_path__ + "img/safe_tool_07.f60491b8.jpg";